"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalShockNatureAbilityHandler = exports.ElementalShockNatureActorAbilityFactory = exports.ElementalShockNatureAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class ElementalShockNatureAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ElementalShockNature;
        this.__typeName = "ElementalShockNature";
    }
}
exports.ElementalShockNatureAbilityArgs = ElementalShockNatureAbilityArgs;
let ElementalShockNatureActorAbilityFactory = class ElementalShockNatureActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ElementalShockNature", "Self", 0);
    }
};
ElementalShockNatureActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ElementalShockNature")
], ElementalShockNatureActorAbilityFactory);
exports.ElementalShockNatureActorAbilityFactory = ElementalShockNatureActorAbilityFactory;
let ElementalShockNatureAbilityHandler = class ElementalShockNatureAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEventHandlerEffectArgs("Elemental Shock: Nature", "Poisons killer", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), "ApplyEffects_OnKilled", {
                target: "killer",
                effects: [{
                        duration: Duration_1.Duration.Ticks(8),
                        effect: new core_1.PoisonedEffectArgs("Focus", 20),
                        percentChance: 100
                    }]
            })),
            supernatural: true,
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
ElementalShockNatureAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ElementalShockNature)
], ElementalShockNatureAbilityHandler);
exports.ElementalShockNatureAbilityHandler = ElementalShockNatureAbilityHandler;
